// extracted by mini-css-extract-plugin
module.exports = {"title-modal":"T7gCYKUtk1ua5AqtHoTru","dialog":"_26_SDsjlUXN0ECngx5Mkz4","header-delete":"_17DT3L8e0rnlwriqlL3yny"};